import { render, staticRenderFns } from "./PDPV3.vue?vue&type=template&id=6eefdc86&scoped=true&"
import script from "./PDPV3.vue?vue&type=script&lang=js&"
export * from "./PDPV3.vue?vue&type=script&lang=js&"
import style0 from "./PDPV3.vue?vue&type=style&index=0&id=6eefdc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eefdc86",
  null
  
)

export default component.exports